import {
  ContainerMenu,
  ContainerNew,
  MenuBox,
  MenuList,
  MenuListDiscr,
  MenuListDiscrItem,
  MenuListDiscrItemText,
  MenuListItem,
  MenuListItemPrice,
  MenuListItemTitle,
  MenuTitle,
  MenuTitleCategory,
  PriceBox,
} from './Menu.styled';
import { useEffect, useState } from 'react';
import menuData from '../../data/menuCart.json';
import { useTranslation } from 'react-i18next';

export const Menu = () => {
  const { i18n } = useTranslation();
  const [menu, setMenu] = useState([]);

  const handlerTranslateMenu = (data, language) => {
    return (
      data?.map(category => ({
        category: category.category[language],
        id: category.id,
        categoryItems: category.categoryItems.map(item => ({
          id: item.id,
          name: item.name[language],
          price: item.price,
          discr: item.discr[language] || '',
        })),
      })) || []
    );
  };

  useEffect(() => {
    const language = i18n.language;
    const translatedMenu = handlerTranslateMenu(menuData, language);
    setMenu(translatedMenu);
  }, [i18n.language]);

  return (
    <ContainerNew>
      <MenuTitle>A la Carte</MenuTitle>

      <ContainerMenu>
        {menu.map(category => (
          <MenuBox key={category.id}>
            <MenuTitleCategory>{category.category}</MenuTitleCategory>
            <MenuList>
              {category.categoryItems.map(item => (
                <MenuListItem key={item.id}>
                  <PriceBox>
                    <MenuListItemTitle>{item.name}</MenuListItemTitle>
                    <MenuListItemPrice>{item.price}€</MenuListItemPrice>
                  </PriceBox>
                  <MenuListDiscr>
                    {item.discr && (
                      <MenuListDiscrItem>
                        <MenuListDiscrItemText>
                          {item.discr}
                        </MenuListDiscrItemText>
                      </MenuListDiscrItem>
                    )}
                  </MenuListDiscr>
                </MenuListItem>
              ))}
            </MenuList>
          </MenuBox>
        ))}
      </ContainerMenu>
    </ContainerNew>
  );
};
